export const DISASTER_SCENARIOS = Object.freeze([
  { text: "Historic (2010-2019)", value: "historic" },
  { text: "SSP2 4.5 (2030-2039)", value: "ssp2_4_5" },
  { text: "SSP5 8.5 (2030-2039)", value: "ssp5_8_5" },
]);

export const DEFAULT_DISASTER_SCENARIO = "Historic (2010-2019)";

export const DISASTER_SCENARIOS_MAP = Object.freeze(
  Object.fromEntries(DISASTER_SCENARIOS.map((s) => [s.text, s.value])),
);

export const DISASTER_EVENT_TYPES = Object.freeze([
  { text: "Drought", value: "drought" },
  { text: "Precipitation", value: "precipitation" },
  { text: "Heatwave", value: "heatwave" },
  { text: "Coldwave", value: "coldwave" },
  { text: "Wind", value: "wind" },
]);

export const DEFAULT_DISASTER_EVENT_TYPE = "Drought";

export const DISASTER_EVENT_TYPES_MAP = Object.freeze(
  Object.fromEntries(DISASTER_EVENT_TYPES.map((e) => [e.text, e.value])),
);

export const DISASTER_EVENT_KEYS = Object.freeze({
  drought: { duration: "drought_duration", frequency: "drought_frequency" },
  precipitation: { duration: "precipitation_duration", frequency: "precipitation_frequency" },
  heatwave: { duration: "heatwave_duration", frequency: "heatwave_frequency" },
  coldwave: { duration: "coldwave_duration", frequency: "coldwave_frequency" },
  wind: { duration: "wind_duration", frequency: "wind_frequency" },
});
